import { useContext, useEffect, useState } from 'react'
import { AppContext } from '@state/context'
import useSWR from 'swr'
import { Sections_Listing } from '@graphql/queries'

const useSections = () => {
    const { data, error, mutate, isValidating } = useSWR(Sections_Listing)
    const [state] = useContext(AppContext)
    const userId = state?.app?.userId

    const [sections, setSections] = useState([])
    const [userCreatedSections, setUserCreatedSections] = useState([])
    const [userSavedSections, setUserSavedSections] = useState([])
    const [publicSections, setPublicSections] = useState([])

    useEffect(() => {
        if (data?.sections?.data) {
            const savedSections = data.sections.data.filter((section) =>
                section.customers.find((customer) => customer.id === userId)
            )

            setSections(data.sections.data)
            setUserCreatedSections(data.sections.data.filter((section) => section.creator?.id === userId))
            setPublicSections(data.sections.data.filter((sections) => sections.published === true))
            setUserSavedSections(savedSections)
        }
    }, [userId, data, isValidating])

    return {
        userCreatedSections,
        publicSections,
        userSavedSections,
        sections,
        error,
        mutate,
        isValidating,
        isLoading: !error && !data,
    }
}

export { useSections }
